
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoadbabsimagicacab() {



    const cardData =
    {
        keyword: 'Pune To Adlabs Imagica Cab Booking',
        heading: 'Mauli Cabs:  Pune To Adlabs Imagica Cab Booking',
        headingDescription: 'Mauli Cabs offers easy and affordable Pune to Adlabs Imagica cab booking services for a fun-filled and stress-free trip. Whether you’re planning a family adventure, a group outing, or a weekend getaway, we provide a variety of vehicles including sedans, SUVs, and premium cabs. Enjoy a smooth journey with professional drivers, transparent pricing, no hidden charges, and a comfortable ride from Pune to Adlabs Imagica.',

        top: 'Top Places to Visit in Imagica with Mauli Cabs',

"topPlaces": [
    {
        "title": "Nitro",
        "description": "Nitro is India's largest and fastest floorless roller coaster, reaching speeds of 65.2 mph and featuring five thrilling inversions. It's a must-try for adrenaline junkies seeking an exhilarating experience."
    },
    {
        "title": "Deep Space",
        "description": "Deep Space is an indoor launched roller coaster that propels riders into a cosmic adventure. With two inversions and a dark, space-themed environment, it offers a unique and intense ride."
    },
    {
        "title": "Mr. India – The Ride",
        "description": "Based on the classic Bollywood film, this motion simulator ride takes guests on a mission to save the world from the villain Mogambo. It's a family-friendly attraction filled with excitement and nostalgia."
    },
    {
        "title": "I for India",
        "description": "I for India is a flying theater experience that offers a breathtaking aerial tour of India's diverse landscapes and landmarks, providing a unique perspective of the country's beauty."
    },
    {
        "title": "Rajasaurus River Adventure",
        "description": "This thrilling water ride combines a gentle river journey with sudden drops and encounters with animatronic dinosaurs, making it an exciting adventure for all ages."
    },
    {
        "title": "Scream Machine",
        "description": "Scream Machine is a giant pendulum ride that swings riders high into the air while spinning, offering a combination of weightlessness and high-speed thrills."
    },
    {
        "title": "Wrath of the Gods",
        "description": "An immersive walkthrough attraction that combines special effects, storytelling, and mythology, Wrath of the Gods takes visitors on a journey through ancient legends."
    },
    {
        "title": "Salimgarh",
        "description": "Salimgarh is a haunted house attraction that guides guests through a dark and eerie fortress, filled with spine-chilling surprises and ghostly encounters."
    },
    {
        "title": "Alibaba Aur Chalis Chorr",
        "description": "This interactive dark ride allows guests to join Alibaba in his quest against the 40 thieves, featuring elaborate sets, animatronics, and engaging storytelling."
    },
    {
        "title": "Tubbby Takes Off",
        "description": "A delightful ride for young children, Tubbby Takes Off offers gentle movements and colorful visuals, making it a perfect introduction to theme park rides for the little ones."
    }
],

"services": [
    {
        "name": "Pune to Adlabs Imagica Cab Service",
        "description": "Mauli Cabs offers reliable cab services from Pune to Adlabs Imagica. Enjoy a safe and comfortable ride to one of India’s top amusement parks with our professional drivers."
    },
    {
        "name": "Book Pune to Adlabs Imagica Taxi",
        "description": "Book your taxi from Pune to Adlabs Imagica with Mauli Cabs for a convenient and hassle-free experience. We offer easy booking options and prompt service."
    },
    {
        "name": "Affordable Pune to Adlabs Imagica Cab",
        "description": "Looking for a budget-friendly ride to Adlabs Imagica? Mauli Cabs offers affordable taxi options without compromising on comfort or quality."
    },
    {
        "name": "Private Taxi for Adlabs Imagica from Pune",
        "description": "Travel privately from Pune to Adlabs Imagica with Mauli Cabs. Enjoy complete privacy and convenience in our well-maintained vehicles."
    },
    {
        "name": "Adlabs Imagica Trip by Cab from Pune",
        "description": "Plan your fun-filled trip to Adlabs Imagica with Mauli Cabs. Our reliable cabs ensure a smooth ride so you can focus on enjoying your adventure."
    },
    {
        "name": "Pune to Adlabs Imagica One-Way or Round Trip",
        "description": "Whether you need a one-way drop or a round trip, Mauli Cabs offers flexible cab options from Pune to Adlabs Imagica to fit your travel plans."
    },
    {
        "name": "Group Travel to Adlabs Imagica from Pune",
        "description": "Traveling with friends or family? Mauli Cabs provides spacious vehicles perfect for group travel from Pune to Adlabs Imagica. Enjoy a fun and comfortable journey together."
    },
    {
        "name": "Comfortable Taxi Ride from Pune to Adlabs Imagica",
        "description": "Mauli Cabs ensures a comfortable taxi ride to Adlabs Imagica from Pune with clean vehicles and courteous drivers, making your journey enjoyable from start to finish."
    },
    {
        "name": "Luxury Cab for Adlabs Imagica Trip",
        "description": "Travel in style to Adlabs Imagica with Mauli Cabs' luxury cab options. Enjoy a premium experience with plush seating and top-notch service."
    },
    {
        "name": "Pune to Imagica Tour by Taxi",
        "description": "Book a full-day tour from Pune to Imagica with Mauli Cabs. Our taxi services are ideal for those looking to explore the park at their own pace and comfort."
    }
],

"tableData": [
    ["Pune to Adlabs Imagica Cab Service", "Book Pune to Adlabs Imagica Taxi"],
    ["Affordable Pune to Adlabs Imagica Cab", "Private Taxi for Adlabs Imagica from Pune"],
    ["Adlabs Imagica Trip by Cab from Pune", "Pune to Adlabs Imagica One-Way or Round Trip"],
    ["Group Travel to Adlabs Imagica from Pune", "Comfortable Taxi Ride from Pune to Adlabs Imagica"],
    ["Luxury Cab for Adlabs Imagica Trip", "Pune to Imagica Tour by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "At Mauli Cabs, we ensure that your Pune to Adlabs Imagica Cab Booking is timely and reliable. Whether you’re heading for a fun day at the theme park or a family outing, our drivers ensure punctual pickups and drop-offs so you can enjoy a stress-free journey."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a range of vehicles for your Pune to Adlabs Imagica Cab, from sedans to SUVs and premium cars. Each vehicle is equipped with air conditioning, ample legroom, and spacious interiors, ensuring a comfortable ride to the exciting destination."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to Adlabs Imagica, ensuring a smooth and safe journey. With their knowledge of the road and traffic patterns, they ensure you have a comfortable and hassle-free trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs provides affordable and transparent pricing for your Pune to Adlabs Imagica Cab Booking. We offer competitive rates with no hidden charges, so you can enjoy your trip without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a safe and enjoyable ride to Adlabs Imagica."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available round-the-clock for your Pune to Adlabs Imagica Cab Booking. Whether you're planning a morning trip or a late return, our customer service team is ready to assist you at any time of the day or night."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Adlabs Imagica Cab is quick and simple with Mauli Cabs. You can book online through our website or mobile app, or reach out to our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling with family, friends, or solo, Mauli Cabs offers customized travel packages for your Pune to Adlabs Imagica Cab Booking. Share your preferences with us, and we’ll tailor your journey to make it even more enjoyable."
    }
]








    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Adlabs Imagica with Mauli Cabs?',
            answer: 'Booking your cab is easy! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Adlabs Imagica as your destination, then choose the vehicle that fits your needs. Alternatively, you can call our support team for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Adlabs Imagica?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the one that fits your comfort and space requirements for the trip to Imagica.',
        },
        {
            question: 'Is the fare from Pune to Adlabs Imagica fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. You will know the total fare upfront with no hidden costs.',
        },
        {
            question: 'Can I book a round trip from Pune to Adlabs Imagica?',
            answer: 'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we will take care of the rest.',
        },
        {
            question: 'How long does the journey from Pune to Adlabs Imagica take?',
            answer: 'The ride from Pune to Adlabs Imagica typically takes around 2 to 2.5 hours, depending on traffic and road conditions. We ensure a smooth and timely journey so you can enjoy your time at Imagica.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Adlabs Imagica route?',
            answer: 'Yes, our drivers are well-trained, experienced, and familiar with the best routes to ensure a safe and comfortable ride to Adlabs Imagica.',
        },
        {
            question: 'Can I book a cab for sightseeing around Adlabs Imagica?',
            answer: 'Yes, Mauli Cabs offers customized sightseeing tours around Adlabs Imagica. Whether you want to explore nearby attractions or visit other fun spots, our drivers will ensure you have a great experience.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Absolutely! All our cabs are fully air-conditioned and well-maintained for comfort and cleanliness. We ensure a pleasant and hygienic ride to Imagica.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. Our flexible cancellation policy is available through our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Adlabs Imagica trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and reliable service. Whether for family fun or a group outing, we ensure a comfortable and hassle-free trip to Adlabs Imagica.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rohit Kumar",
            position: "Family Trip Planner",
            text: "The trip to Adlabs Imagica was amazing! The cab was comfortable, and the driver made sure we reached on time. We had a great time at Imagica, thanks to Mauli Cabs for a smooth ride!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Anjali Mehta",
            position: "Adventure Seeker",
            text: "I had an unforgettable experience visiting Adlabs Imagica with Mauli Cabs. The ride was smooth, and the driver was friendly and helpful. Highly recommend their services for trips like this!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Adlabs Imagica Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and reliable cab services from Pune to Adlabs Imagica. Choose from private, luxury, or group taxis for one-way or round-trip journeys. Enjoy a comfortable ride for your Imagica adventure with 24x7 online booking.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "3600"
        }
      };
      
    
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Adlabs Imagica Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Adlabs Imagica cab with Mauli Cabs. Comfortable and affordable private, luxury, or group taxis for a fun trip. One-way and round-trip options with 24x7 booking available."
        />
        <meta
          name="keywords"
          content="Pune to Adlabs Imagica cab service, Book Pune to Adlabs Imagica taxi, Affordable Pune to Adlabs Imagica cab, Private taxi for Adlabs Imagica from Pune, Adlabs Imagica trip by cab from Pune, Pune to Adlabs Imagica one-way or round trip, Group travel to Adlabs Imagica from Pune, Comfortable taxi ride from Pune to Adlabs Imagica, Luxury cab for Adlabs Imagica trip, Pune to Imagica tour by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoadbabsimagicacab;